// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
import physiqueList from '@/views/physique/list';
import meridianList from '@/views/meridian/list';
import tongueList from '@/views/tongue/list';
import combinationList from '@/views/combination/list';
import appList from '@/views/app/list';
import userList from '@/views/user/list';
import home from '@/views/system/home';


// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [
          {
            path: '/system/home',
            name: '看板页',
            component: home,
            meta: {
                requireAuth: true
            }
          },
          {
            path: '/physique/list',
            name: 'physiqueList',
            component: physiqueList,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/meridian/list',
            name: 'meridianList',
            component: meridianList,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/tongue/list',
            name: 'tongueList',
            component: tongueList,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/combination/list',
            name: 'combinationList',
            component: combinationList,
            meta: {
              requireAuth: true
            }
          },
          {
            path: '/app/list',
            name: '应用管理',
            component: appList,
            meta: {
                requireAuth: true
            }
          },
          {
            path: '/user/list',
            name: '用户列表',
            component: userList,
            meta: {
                requireAuth: true
            }
          }/*,
          {
            path: '/school/list',
            name: '校区管理',
            component: school,
            meta: {
                requireAuth: true
            }
          },
          {
            path: '/account/listAccount',
            name: '账号管理',
            component: listAccount,
            meta: {
                requireAuth: true
            }
          }*/

        ]
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js